var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function () { return ({
    components: {
        MuiFormHelperText: {
            styleOverrides: {
                root: __assign(__assign({}, muiTypography.uiTextSmall), { color: designTokens.color.gray.limestone.value, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', margin: '4px 0 0', '& .MuiSvgIcon-root': {
                        fontSize: '1.125rem',
                    } }),
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formHelperTextTheme.js.map